export default {
    isOpen(state){
        return state.isOpen;
    },
    professor_data(state){
        return state.professor_data;
    },
    research_project_data(state){
        return state.research_project_data;
    },
    professor_experience(state){
        return state.professor_experience;
    },
    professor_honor(state){
        return state.professor_honor;
    },
    professor_teaching(state){
        return state.professor_teaching;
    },
    papers(state){
        return state.papers;
    },
    seminar(state){
        return state.seminar;
    },
    equipment(state){
        return state.equipment;
    },
    student(state){
        return state.student;
    },
    poster(state){
        return state.poster;
    }
    
};